import { useDispatch } from 'react-redux';
import type { ThunkDispatch } from 'redux-thunk';
import type { AnyAction } from 'redux';

import rootReducer from '../store/reducers';

type ReduxState = ReturnType<typeof rootReducer>;
export type TypedDispatch = ThunkDispatch<ReduxState, any, AnyAction>;

// Create a typed dispatch hook to remedy following typescript error:
// Argument of type '(dispatch: any) => void' is not assignable to parameter of type 'AnyAction'.
const useTypedDispatch = () => useDispatch<TypedDispatch>();

export default useTypedDispatch;
